import PropTypes, { InferProps } from 'prop-types';
import { Root } from './CopyrightNotice.styled';

const CopyrightNoticePropTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light'])
};

export interface CopyrightNoticeProps extends InferProps<typeof CopyrightNoticePropTypes> {
  variant?: 'dark' | 'light';
}

export function CopyrightNotice({ className, variant }: CopyrightNoticeProps) {
  return (
    <Root className={className ?? undefined} $variant={variant ?? 'light'}>
      &copy; {new Date().getFullYear()} News Revenue Hub
    </Root>
  );
}

CopyrightNotice.propTypes = CopyrightNoticePropTypes;
export default CopyrightNotice;
